export const APP_VERSION = __APP_VERSION__;
export const APP_COMMIT = __APP_COMMIT__;
export const APP_BUILD_TIME = __APP_BUILD_TIME__;

export const REPOSITORY_URL = "https://github.com/baditaflorin/physical-kanban-sync";
export const PAYPAL_URL = "https://www.paypal.com/paypalme/florinbadita";
export const LIVE_URL = "https://baditaflorin.github.io/physical-kanban-sync/";
